import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthenticationGuard} from '@datev/ngx-dcal';
import {ErrorComponent} from './error/error.component';
import {UebersichtComponent} from './uebersicht/uebersicht.component';
import {LicenseComponent} from './license/license.component';
import {LicenseTextResolver} from './shared/resolver/license-text.resolver';
import {DocumentTypResolver} from './shared/resolver/document-typ.resolver';
import {FragebogenComponent} from './fragebogen/fragebogen.component';
import {environment} from '../environments/environment';
import {RedirectGuard} from '@common-ui-lib';
import {PDF_VIEWER_PATH} from './pdf-viewer/pdf-viewer.routing.module';
import {AttachmentConfigResolver} from './shared/resolver/attachment-config.resolver';
import {DateHelper} from '@utils-lib';

const routes: Routes = [
  {
    path: PDF_VIEWER_PATH,
    canActivate: [AuthenticationGuard],
    loadChildren: () => import('./pdf-viewer/pdf-viewer.module').then(m => m.PdfViewerModule),
  },
  {
    path: 'error/:error',
    canActivate: [AuthenticationGuard],
    component: ErrorComponent,
    data: {
      header: 'FRAGEBOEGEN_APP.GLOBAL_ERROR.TITLE',
      message: 'FRAGEBOEGEN_APP.GLOBAL_ERROR.MESSAGE',
      linkLabel: 'FRAGEBOEGEN_APP.GLOBAL_ERROR.ZUR_UEBERSICHT',
      linkValue: environment.redirectPath
    }
  },
  {
    path: 'unavailable/:error',
    canActivate: [AuthenticationGuard],
    component: ErrorComponent,
    data: {
      header: 'FRAGEBOEGEN_APP.NAVAILABLE.TITLE',
      message: 'FRAGEBOEGEN_APP.NAVAILABLE.MESSAGE',
      secondMessage: 'FRAGEBOEGEN_APP.NAVAILABLE.SECONDMESSAGE',
      linkLabel: 'www.datev-status.de',
      linkValue: 'https://datev-status.de',
      landingpageLinkText: 'FRAGEBOEGEN_APP.NAVAILABLE.BACK_TO_LANDINGPAGE'
    }
  },
  {
    path: 'forbidden/:error',
    canActivate: [AuthenticationGuard],
    component: ErrorComponent,
    data: {
      header: 'FRAGEBOEGEN_APP.FORBIDDEN_ERROR.TITLE',
      message: 'FRAGEBOEGEN_APP.FORBIDDEN_ERROR.MESSAGE',
      secondMessage: 'FRAGEBOEGEN_APP.FORBIDDEN_ERROR.SECONDMESSAGE',
      linkLabel: '1019647',
      linkValue: 'https://apps.datev.de/help-center/documents/1019647',
      headerQuestionnaire: 'FRAGEBOEGEN_APP.FORBIDDEN_ERROR.TITLE_QUESTIONNAIRE',
      messageQuestionnaire: 'FRAGEBOEGEN_APP.FORBIDDEN_ERROR.MESSAGE_QUESTIONNAIRE',
      landingpageLinkText: 'FRAGEBOEGEN_APP.FORBIDDEN_ERROR.BACK_TO_LANDINGPAGE',
      questionnaireLinkText: 'FRAGEBOEGEN_APP.FORBIDDEN_ERROR.BACK_TO_QUESTIONNAIRE',
      messageConjunct: 'FRAGEBOEGEN_APP.FORBIDDEN_ERROR.MESSAGE_CONJUNCT'
    }
  },
  {
    path: 'license',
    canActivate: [AuthenticationGuard],
    component: LicenseComponent,
    resolve: {
      licenseText: LicenseTextResolver
    }
  },
  {
    path: environment.parentProject,
    pathMatch: 'full',
    canActivate: [AuthenticationGuard, RedirectGuard],
    component: RedirectGuard
  },
  {
    path: '',
    pathMatch: 'full',
    canActivate: [AuthenticationGuard, RedirectGuard],
    component: RedirectGuard
  },
  {
    path: 'list',
    canActivate: [AuthenticationGuard],
    component: UebersichtComponent
  },
  {
    path: ':taskId',
    canActivate: [AuthenticationGuard],
    component: FragebogenComponent,
    resolve: {
      fragebogen: DocumentTypResolver
    }
  },
  {
    path: 'fragebogen-eun',
    loadChildren: () => import('./fragebogen/eun/eun.module').then(m => m.EunModule),
    canActivate: [
      AuthenticationGuard
    ],
    resolve: {
      config: AttachmentConfigResolver
    }
  },
  {
    path: 'fragebogen-kap-ges',
    loadChildren: () => import('./fragebogen/kap-ges/kap-ges.module').then(m => m.KapGesModule),
    canActivate: [
      AuthenticationGuard
    ],
    resolve: {
      config: AttachmentConfigResolver
    }
  },
  {
    path: 'fragebogen-pers-ges',
    loadChildren: () => import('./fragebogen/pers-ges/pers-ges.module').then(m => m.PersGesModule),
    canActivate: [
      AuthenticationGuard
    ],
    resolve: {
      config: AttachmentConfigResolver
    }
  },
  {
    path: DateHelper.isDateOlderThanDeadline() ? 'fragebogen-betpg' : 'termination-message/:taskId',
    loadChildren: DateHelper.isDateOlderThanDeadline()
      ? () => import('./fragebogen/betpg/betpg.module').then(m => m.BetpgModule)
      : () => import('./fragebogen/betpg/termination-message/termination-message.module').then(m => m.TerminationMessageModule),
    canActivate: [
      AuthenticationGuard
    ],
    resolve: {
      config: AttachmentConfigResolver
    }
  },
  {
    path: 'fragebogen-kapg-aus',
    loadChildren: () => import('./fragebogen/kapg-aus/kapg-aus.module').then(m => m.KapgAusModule),
    canActivate: [
      AuthenticationGuard
    ],
    resolve: {
      config: AttachmentConfigResolver
    }
  },

  {
    path: '**',
    pathMatch: 'full',
    component: ErrorComponent,
    data: {
      header: 'FRAGEBOEGEN_APP.NOT_FOUND_ERROR.TITLE',
      message: 'FRAGEBOEGEN_APP.NOT_FOUND_ERROR.MESSAGE',
      linkLabel: 'FRAGEBOEGEN_APP.GLOBAL_ERROR.ZUR_UEBERSICHT',
      linkValue: environment.redirectPath
    }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'top'})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
